import { faEdit } from "@fortawesome/pro-regular-svg-icons/faEdit";
import { faGamepad } from "@fortawesome/pro-solid-svg-icons/faGamepad";
import { faReplyAll } from "@fortawesome/pro-solid-svg-icons/faReplyAll";
import { faSignIn } from "@fortawesome/pro-solid-svg-icons/faSignIn";
import * as api from "api/Core";
import { AppMessageBox } from "components/AppMessageBox";
import { SpinnerIndicator } from "components/CallServer";
import DashListBox, { DashBoxListItem } from "components/Dashboard/DashListBox";
import MuiContainer from "components/MuiExtras/MuiContainer";
import LibUtils from "lib/LibUtils";
import { DashboardUserAndGroupsFilter, DashboardUserAndGroupsParticipationResumeModel, DashboardUserAndGroupsParticipationSummaryColumn } from "models/ApiModels";
import * as React from "react";
import { WithTranslation } from "react-i18next";

/////////////////////////////////////////////////////////////////////////////////////

interface IProps {
    activeTile: DashboardUserAndGroupsParticipationSummaryColumn;
    filter: DashboardUserAndGroupsFilter;
    onChange: (tile: DashboardUserAndGroupsParticipationSummaryColumn) => void;
}

interface IState {
    data: DashboardUserAndGroupsParticipationResumeModel;
    loading: boolean;
}

type Props = IProps & WithTranslation;

export default class ParticipationTiles extends React.PureComponent<Props, IState>
{
    constructor(props: Props) {
        super(props);

        this.state = {
            data: null,
            loading: true,
        };
    }

    ///
    private loadData() {

        this.setState({ loading: true });

        api.getDashboardUserAndGroupsParticipationPublication(
            {
                columnToSummary: DashboardUserAndGroupsParticipationSummaryColumn.Resume,
                startDate: null,
                endDate: null,
                ...this.props.filter
            })
            .then((result: DashboardUserAndGroupsParticipationResumeModel) => {
                this.setState({ data: result, loading: false });
            })
            .catch((error) => {
                this.setState({ data: null, loading: false });
            });
    }

    ///
    private handleTileClick(tile: DashboardUserAndGroupsParticipationSummaryColumn) {
        this.props.onChange(tile);
    }

    ///
    private renderBoxes() {
        const { loading, data } = this.state;
        const { activeTile } = this.props;
        const last30 = this.props.t("Views.Dashboards.Common.InLastMonth");

        var boxes: DashBoxListItem[] = [
            {
                key: DashboardUserAndGroupsParticipationSummaryColumn.Accesses,
                title: loading ? <SpinnerIndicator /> : `${(data.activeUsers > 0) ? Math.round(data.accesses7 / data.activeUsers * 100.0).toFixed(0):"0"}%`,
                subtitle: this.props.t("Views.Dashboards.UserAndGroups.ParticipationTiles.Access"),
                description: loading ? "" : this.props.t("Views.Dashboards.Common.InLastWeek"),
                icon: faSignIn,
            },
            {
                key: DashboardUserAndGroupsParticipationSummaryColumn.Publications,
                title: loading ? <SpinnerIndicator /> : data.publications.toLocaleString(),
                subtitle: this.props.t("Views.Dashboards.UserAndGroups.ParticipationTiles.Publications"),
                description: loading ? "" : `${data.publications30} ${last30}`,
                icon: faEdit,
            },
            {
                key: DashboardUserAndGroupsParticipationSummaryColumn.Answers,
                title: loading ? <SpinnerIndicator /> : data.answers.toLocaleString(),
                subtitle: this.props.t("Views.Dashboards.UserAndGroups.ParticipationTiles.Answers"),
                description: loading ? "" : `${data.answers30} ${last30}`,
                icon: faReplyAll,
            },
            {
                key: DashboardUserAndGroupsParticipationSummaryColumn.KnowledgeTests,
                title: loading ? <SpinnerIndicator /> : data.knowledgeTests.toLocaleString(),
                subtitle: this.props.t("Views.Dashboards.UserAndGroups.ParticipationTiles.KnowledgeTests"),
                description: loading ? "" : `${data.knowledgeTests30} ${last30}`,
                icon: faGamepad,
            }
        ];

        return (
            <>
                <DashListBox
                    color="warning"
                    boxes={boxes}
                    active={activeTile}
                    onClick={
                        (key: DashboardUserAndGroupsParticipationSummaryColumn) => {
                            if (key != activeTile) this.handleTileClick(key);
                        }
                    }
                />
            </>
        );
    }

    ///
    public componentDidMount() {
        this.loadData();
    }

    ///
    public componentDidUpdate(prevProps: Props) {
        if (!LibUtils.isEqual(prevProps.filter, this.props.filter)) {
            this.loadData();
        }
    }

    ///
    public render() {
        const { data, loading } = this.state;
        return (
            <MuiContainer margin="normal" >
                {
                    !loading && data == null
                        ? <AppMessageBox resource="LoadGraphDataFailed" />
                        : this.renderBoxes()
                }
            </MuiContainer>
        );
    }
}